import { useInfiniteQuery } from "@tanstack/react-query";
import { getInvestorRepository } from "@/infrastructure/di";
import { queryKeys } from "../queryKeys";

interface UseInvestorDropdownSearchOptions {
  enabled?: boolean;
  pageSize?: number;
}

/**
 * Transport hook for the investor dropdown: server-side searched, offset-paginated
 * infinite query. UI mapping/debounce/preselection live in the presentation-layer hook.
 */
export const useInvestorDropdownSearch = (
  orgId: string,
  search: string,
  { enabled = true, pageSize = 20 }: UseInvestorDropdownSearchOptions = {},
) => {
  return useInfiniteQuery({
    queryKey: queryKeys.investorDropdown.search(orgId, search),
    queryFn: ({ pageParam = 0, signal }) =>
      getInvestorRepository().list(
        {
          search: search || undefined,
          limit: pageSize,
          offset: pageParam,
        },
        signal,
      ),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage.investors.length === pageSize ? lastPageParam + pageSize : undefined,
    enabled: enabled && !!orgId,
  });
};
